'use es6';

import { isMultiSelect, isFilesArray } from './fieldTypes';
export function shouldDisplayLabelForSchema(schema, definitions = {}) {
  switch (schema.type) {
    case 'array':
      return isMultiSelect(schema, definitions) || isFilesArray(schema, definitions);
    case 'object':
      return false;
    default:
      return true;
  }
}
export function breakLabel(label) {
  return label.replace(/([A-Z])/g, '\u200B$1');
}